import React, { ReactNode } from 'react';

import {
    closestCenter,
    DndContext,
    DragEndEvent,
    DragOverlay,
    DragStartEvent,
    Modifier,
    SensorDescriptor,
    SensorOptions,
} from '@dnd-kit/core';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { createPortal } from 'react-dom';

import { IChecklistTask } from '@features/Checklist/model/types';
import { ChecklistDragPreview } from '@features/Checklist/ui';

interface IChecklistSortableProps {
    checklist: IChecklistTask[];
    activeChecklistItem: IChecklistTask | null;
    sensors: SensorDescriptor<SensorOptions>[];
    modifiers: Modifier[];
    onDragStart: (event: DragStartEvent) => void;
    onDragCancel: () => void;
    onDragEnd: (event: DragEndEvent) => void;
    children: ReactNode;
}

export const ChecklistSortable = ({
    checklist,
    activeChecklistItem,
    sensors,
    modifiers,
    onDragStart,
    onDragCancel,
    onDragEnd,
    children,
}: IChecklistSortableProps) => (
    <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        modifiers={[restrictToVerticalAxis, ...modifiers]}
        onDragStart={onDragStart}
        onDragCancel={onDragCancel}
        onDragEnd={onDragEnd}
    >
        <SortableContext
            items={checklist.map((item) => item.clientId)}
            strategy={verticalListSortingStrategy}
        >
            {children}
        </SortableContext>
        {createPortal(
            <DragOverlay
                style={{
                    pointerEvents: 'none',
                    zIndex: 10000,
                }}
                dropAnimation={null}
            >
                {activeChecklistItem && <ChecklistDragPreview itemData={activeChecklistItem} />}
            </DragOverlay>,
            document.body
        )}
    </DndContext>
);
